export * from './old/Panel_ResourceManager_V1_old.js';
